<script>
/* import { layoutComputed } from '@state/helpers' */
import Vertical from '@layouts/horizontal'
import VueCookie from 'vue-cookie'

export default {
  name:'Main',
  components: { Vertical },
  data() {
    return {}
  },
  methods: {
    getLanguage(){
      VueCookie.set('language', this.user.lang || 'us', 7)
      this.$i18n.locale = this.user.lang || 'us'
      
      if (this.$refs && this.$refs.language && Object.entries(this.$refs.language).length) {
        this.$refs['language'].value = this.user.lang || 'us'
      }
    }
  },
  computed: {
    key() {
      return this.$route.path
    }
  },
  created() {
    this.getLanguage()
  }
}
</script>

<template>
  <Vertical >
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </Vertical>
</template>
